import { render } from "./Question.vue?vue&type=template&id=807dc696&scoped=true"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"

import "./Question.vue?vue&type=style&index=0&id=807dc696&lang=css&scoped=true"

import exportComponent from "/codebuild/output/src173764375/src/givergy_presenter_admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-807dc696"]])

export default __exports__